import { Toast } from "@husqvarna/ui-core";
import { useIntl } from "react-intl";

export type FeedbackToastProps = {
    show: boolean;
    success: boolean;
    text?: string;
}

const FeedbackToast = ({
    show,
    success,
    text
}: FeedbackToastProps) => {
    const intl = useIntl();

    const getDefaultText = () => {
        if (success) {
          return intl.formatMessage({
            id: "general.saveSuccessful",
            defaultMessage: "Your changes have been saved."
          });
        }
        
        return intl.formatMessage({
          id: "general.saveFailed",
          defaultMessage: "Your changes could not be saved. Please try again."
        })
      }

    return (
        <>
            <Toast show={show && success}
                target="#toast-container"
                icon="check"
                variant="SuccessGreen"
                text={text ?? getDefaultText()}></Toast>
            <Toast show={show && !success}
                target="#toast-container"
                icon="close"
                variant="ErrorRed"
                text={text ?? getDefaultText()}></Toast>
        </>
    )
}

export default FeedbackToast;